<script lang="ts">
  import { onMount, createEventDispatcher } from 'svelte';

  import type { AnimationItem, LottiePlayer } from 'lottie-web';

  import animationData from '../data/DO-icon-lottie.json';

  import { initLottieLifecycle } from '../libs';
  import { iconDOTriggers } from '../models';

  import type { LottieUID } from '../types';
  import { triggeredUIDs } from '../models/triggered-UIDs';

  const dispatch = createEventDispatcher<{ 'lottie-loaded': void }>();

  export let width: number;

  export let uid: LottieUID;
  initLottieLifecycle(uid);

  $: ({ loop, endLoop, oneTime, appear } = $iconDOTriggers); // <- Triggers

  $: loop && lot && triggeredUIDs.exist(uid, 'loop') && loopAnimation();
  $: endLoop && lot && triggeredUIDs.exist(uid, 'endLoop') && endLoopAnimation();
  $: oneTime && lot && triggeredUIDs.exist(uid, 'oneTime') && oneTimeAnimation();
  $: appear && lot && triggeredUIDs.exist(uid, 'appear') && appearAnimation();

  let lot: AnimationItem;
  function loopAnimation() {
    lot.setLoop(true);
    if (lot.isPaused) lot.goToAndPlay(1);
  }
  function endLoopAnimation() {
    lot.setLoop(false);
  }
  function oneTimeAnimation() {
    lot.setLoop(false);
    lot.play();
  }

  let appeared = true;
  function appearAnimation() {
    appeared = false;
    lot.setLoop(false);
    lot.goToAndStop(24, true);

    setTimeout(() => (appeared = true), 0);
    setTimeout(() => lot.play(), 150);
  }

  let container: HTMLDivElement;
  onMount(async () => {
    const lottie = (await import('lottie-web')) as unknown as LottiePlayer;
    lot = lottie.loadAnimation({
      container,
      animationData,
      loop: true,
      autoplay: false,
      initialSegment: [1, 50],
    });
    dispatch('lottie-loaded');
  });
</script>

<div
  bind:this="{container}"
  style="width: {width}px; height: {width}px"
  class="transition-opacity duration-300 {appeared ? 'delay-150' : 'opacity-0'}"
></div>
